import React, { useEffect, useState } from 'react'
import UnitCountTwo from './child/UnitCountTwo'
import RevenueGrowthOne from './child/RevenueGrowthOne'
import EarningStaticOne from './child/EarningStaticOne'
import CampaignStaticOne from './child/CampaignStaticOne'
import ClientPaymentOne from './child/ClientPaymentOne'
import CountryStatusOne from './child/CountryStatusOne'
import TopPerformanceOne from './child/TopperformanceOne'
import LatestPerformanceOne from './child/LatestPerformanceOne'
import LastTransactionOne from './child/LastTransactionOne'
import { API_URL } from '..'

const DashBoardLayerTwo = () => {
  const [data, setData ]   = useState({
    totalJobs: 0,
    activeJobs : 0,
    declinedJobs : 0,
    totalInvoices : 0,
    totalStaff: 0,
  })
  useEffect(()=>{
    const fetchDashboad = async() =>{
      const fetchApi = await fetch(API_URL+'/api/job/dashboard' , { method : 'GET'});
      const response = await fetchApi.json();
      if(fetchApi.status ===200){
        setData(response.data);
      }
    }
    fetchDashboad();
  },[1])
    return (
    <section className="row gy-4">

      {/* UnitCountTwo */}
      
      <UnitCountTwo  data={data}/>

      
      {/* LastTransactionOne */}
      {/* <LastTransactionOne /> */}
    </section>

  )
}

export default DashBoardLayerTwo